const initialState = {
  // Getting User list
  isGettingClientList: false,
  clientList: [],

  // Editing Client 
  isEditingClientList: false,
};

const ClientListReducer = (state = initialState, action) => {
  switch (action.type) {
    // Getting Client List
    case "CLIENT_LIST_REQUEST":
      return {
        ...state,
        isGettingClientList: true,
      };
    case "CLIENT_LIST_SUCCESS":
      return {
        ...state,
        clientList: action.payload,
        isGettingClientList: false,
      };
    case "CLIENT_LIST_ERROR":
      return {
        ...state,
        isGettingClientList: false,
      };
    // Editing Client List
    case "EDIT_CLIENT_REQUEST":
      return {
        ...state,
        isEditingClientList: true,
      };
    case "EDIT_CLIENT_SUCCESS":
      return {
        ...state,
        isEditingClientList: false,
      };
    case "EDIT_CLIENT_ERROR":
      return {
        ...state,
        isEditingClientList: false,
      };
    default:
      return state;
  }
};

export default ClientListReducer;
